import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, change } from 'redux-form';
import Button from '../../elements/Button';
import LoadingBars from '../../elements/LoadingBars';
import RadioList from '../../elements/RadioList';
import Text from '../../fields/Text';
import styles from './styles.scoped.css';
import { Checkbox } from '@mantine/core';
import TextArea from '../../fields/TextArea/TextArea';
import { clearRedux } from '../../../pages/SettingBusinessType/actions';


export function FormEditBusinessType({
  handleSubmit,
  handleClose,
  data,
  valid,
}){
  const dispatch = useDispatch();
  const [isConfirm, setIsConfirm] = useState(false);
  const { values } = useSelector((state) => state.form.FormEditBusinessType);
  const {
    isLoadingUpdateBusinessType,
    dataUpdateBusinessType,
    messageUpdateBusinessType,
  } = useSelector((state) => state.settingBusinessType);
  const isDuplicate = dataUpdateBusinessType?.code === 409;

  useEffect(() => {
    if (data?.name) {
      dispatch(change('FormEditBusinessType', 'businessTypeName', data.name));
      dispatch(change('FormEditBusinessType', 'codeKbli', String(data.kbli)));
      dispatch(change('FormEditBusinessType', 'kbliVersion', String(data.kbliVersion)));
      dispatch(change('FormEditBusinessType', 'description', data.description));
    }
  }, [data, dispatch]);

  useEffect(() => {
    if(!/^[0-9]*$/.test(values.codeKbli)){
      const codeKbli = values.codeKbli.replace(/[^0-9]/g, '');
      dispatch(change('FormEditBusinessType', 'codeKbli', codeKbli));
    }
  }, [values.codeKbli]);

  useEffect(() => {
    if (isDuplicate) {
      dispatch(clearRedux('UpdateBusinessType'));
    }
  }, [values.codeKbli, values.businessTypeName]);

  const enableSubmit = () => {
    return valid && values?.businessTypeName
    && values?.codeKbli && values?.kbliVersion && values?.description && isConfirm;
  };

  const onSubmit = async(e) => {
    e.preventDefault();
    const body = {
      codeKbli: values.codeKbli,
      kbliVersion: values.kbliVersion,
      name: values.businessTypeName.trim(),
      description: values.description,
    };
    handleSubmit(body);
  };

  return(
    <form onSubmit={onSubmit}>
      <div className={styles.radioField}>
        <Field
          component={RadioList}
          inputProps={{
            label: 'Tahun KBLI',
            required: true,
            defaultValue: values?.kbliVersion,
          }}
          items={[
            { label: '2020', value: '2020' },
            { label: '2025', value: '2025' },
          ]}
          name={'kbliVersion'}
        />
      </div>
      <Field
        autoComplete="off"
        component={Text}
        inputProps={{
          label: 'Kode KBLI',
          required: true,
          placeholder: 'Masukkan kode KBLI',
          maxLength: 10,
        }}
        isErrorField={isDuplicate}
        name={'codeKbli'}
        required={true}
      />
      <Field
        autoComplete="off"
        component={Text}
        inputProps={{
          label: 'Jenis Usaha',
          required: true,
          placeholder: 'Masukkan Jenis Usaha',
        }}
        isErrorField={isDuplicate}
        name={'businessTypeName'}
        required={true}
        serverError={isDuplicate ? messageUpdateBusinessType : ''}
      />
      <Field
        component={TextArea}
        inputProps={{
          label: 'Deskripsi',
          required: true,
          placeholder: 'Masukkan deskripsi jenis usaha',
        }}
        maxLength={100}
        name={'description'}
        required={true}
      />
      <div className={styles.checkboxField}>
        <Checkbox checked={isConfirm} color="primary-ptm.0" label="Data jenis usaha sudah benar" onChange={(e) => setIsConfirm(e.currentTarget.checked)} styles={{
          label: {
            fontWeight: 400,
            fontSize: '13px !important'
          },
          body: {
            alignItems: 'center',
          },
        }}/>
      </div>
      <div className={styles.actionBtn}>
        <Button
          className={styles.action}
          fullWidth
          onClick={handleClose}
          outlined
          type={'button'}>
          Batal
        </Button>
        <Button
          className={styles.action}
          disabled={!enableSubmit() || isLoadingUpdateBusinessType}
          fullWidth
          style={'blue'}
          type={'submit'}>
          {isLoadingUpdateBusinessType && <LoadingBars size={1} />}
          Perbarui Jenis Usaha
        </Button>
      </div>
    </form>
  );
}

export default FormEditBusinessType;

FormEditBusinessType.propTypes = {
  data: PropTypes.object,
  handleClose: PropTypes.func,
  handleReset: PropTypes.func,
  handleSubmit: PropTypes.func,
  valid: PropTypes.bool,
};

